import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useMe } from "@/context/MeContext";
import { STATUS, eur } from "@/lib/api";

export default function Cart() {
  const { items, setQty, remove } = useCart();
  const { me, isSignedIn } = useMe();
  const navigate = useNavigate();
  const status = me?.status || "bronze";
  const total = items.reduce((s, i) => s + i.offer[`price_${status}`] * i.qty, 0);
  const partners = new Set(items.map((i) => i.offer.partner_id));

  if (!items.length)
    return (
      <div className="py-24 text-center" data-testid="cart-empty">
        <p className="text-slate-400">Il carrello è vuoto.</p>
        <Link to="/marketplace" className="mt-4 inline-block text-amber-400 hover:underline">Vai al Marketplace</Link>
      </div>
    );

  return (
    <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6" data-testid="cart-page">
      <h1 className="font-display text-4xl font-extrabold text-white">Carrello</h1>
      {partners.size > 1 && <p className="mt-2 text-sm text-slate-400">Il carrello contiene prodotti di {partners.size} aziende: verrà diviso in {partners.size} ordini.</p>}
      <div className="mt-8 space-y-3">
        {items.map(({ offer, qty }) => (
          <div key={offer.id} data-testid={`cart-item-${offer.id}`} className="flex items-center gap-4 rounded-2xl border border-white/10 bg-[#12141C] p-4">
            <img src={offer.image_url} alt="" className="h-16 w-16 rounded-xl object-cover" onError={(e) => (e.currentTarget.style.visibility = "hidden")} />
            <div className="flex-1">
              <p className="font-semibold text-white">{offer.name}</p>
              <p className="text-xs text-slate-500">{offer.partner_name}</p>
              <p className="text-sm" style={{ color: STATUS[status].color }}>{eur(offer[`price_${status}`])} · prezzo {STATUS[status].label}</p>
            </div>
            <div className="flex items-center gap-2">
              <button data-testid={`cart-dec-${offer.id}`} onClick={() => setQty(offer.id, qty - 1)} className="rounded-full border border-white/10 p-1.5"><Minus className="h-3 w-3" /></button>
              <span className="w-6 text-center text-white">{qty}</span>
              <button data-testid={`cart-inc-${offer.id}`} onClick={() => setQty(offer.id, Math.min(qty + 1, offer.stock))} className="rounded-full border border-white/10 p-1.5"><Plus className="h-3 w-3" /></button>
            </div>
            <button data-testid={`cart-remove-${offer.id}`} onClick={() => remove(offer.id)} className="p-2 text-slate-500 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      <div className="mt-8 flex items-center justify-between rounded-2xl border border-white/10 p-5">
        <span className="text-slate-400">Totale prodotti</span>
        <span data-testid="cart-total" className="font-display text-2xl font-bold text-white">{eur(total)}</span>
      </div>
      <button data-testid="cart-checkout-btn" onClick={() => navigate(isSignedIn ? "/checkout" : "/sign-in", { state: { items, usePoints: false } })}
        className="mt-6 w-full rounded-xl bg-amber-500 py-3 font-semibold text-black hover:bg-amber-400">
        Procedi all'ordine
      </button>
    </div>
  );
}
